import { render } from "./NotificationLine.vue?vue&type=template&id=436d80f7&scoped=true"
import script from "./NotificationLine.vue?vue&type=script&lang=js"
export * from "./NotificationLine.vue?vue&type=script&lang=js"

import "./NotificationLine.vue?vue&type=style&index=0&id=436d80f7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-436d80f7"]])

export default __exports__